export const maskTaxId = (unmaskedTaxId: string | undefined) => {
  if (!unmaskedTaxId) {
    return '';
  }

  if (unmaskedTaxId.length > 5) {
    return `${unmaskedTaxId.slice(0, 3)}-${unmaskedTaxId.slice(3, 5)}-${unmaskedTaxId.slice(5)}`;
  } else if (unmaskedTaxId.length > 3) {
    return `${unmaskedTaxId.slice(0, 3)}-${unmaskedTaxId.slice(3, 5)}`;
  }
  return unmaskedTaxId;
};

export const unMaskTaxId = (maskedTaxId: string | undefined) => {
  return maskedTaxId?.replace(/\D/g, '') || '';
};
